import React, { useEffect, useState } from 'react';

const UseData = () => {
    const[projects,setProject]=useState([])
    const[mprojects,setMProjects]=useState([])
    useEffect(()=>{
        fetch('/data.json')
        .then(res=>res.json())
        .then(data=>setProject(data))
    },[])

    useEffect(() => {
        fetch('/datam.json')
            .then(res => res.json())
            .then(data => setMProjects(data))
    }, [])
    return [projects]
};

export default UseData;